import { ApolloError } from "@apollo/client";
import { EventFlexibilityInput, FlexRange } from "@clockwise/schema/v2";
import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { UpdateMeetingFlexibilityDocument } from "../../flexible-meeting-suggestions-control/graphql/__generated__/UpdateMeetingFlexiblity.v2.generated";
import { FlexMeeting } from "../step-components/flex-meeting-step/utils/suggestion-utils";

export const useOnboardingUpdateEventFlexibility = () => {
  const [editEventFlexibility, { loading: updating, error: updateError }] = useGatewayMutation(
    UpdateMeetingFlexibilityDocument,
  );

  const update = async ({
    variables: { events, eventIdsToToDisable },
    onCompleted,
    onError,
  }: {
    variables: { events: FlexMeeting[]; eventIdsToToDisable: string[] };
    onCompleted?: () => void;
    onError?: (error: ApolloError) => void;
  }) => {
    const input: { events: EventFlexibilityInput[] } = {
      events: [],
    };
    for (const eventId of eventIdsToToDisable || []) {
      input.events.push({
        isFlexible: false,
        externalEventId: eventId.split(" ")[1],
      });
    }
    for (const event of events) {
      if (!eventIdsToToDisable.includes(event.id)) {
        // omit flex if they were marked to disable
        const eventId = event.id.split(" ")[1];
        if (!eventId) continue;
        if (event?.flexType?.type === "Day") {
          input.events.push({
            isFlexible: true,
            externalEventId: eventId,
            flexRange: FlexRange.Day,
          });
          continue;
        }
        if (event?.flexType?.type === "Week") {
          input.events.push({
            isFlexible: true,
            externalEventId: eventId,
            flexRange: FlexRange.Week,
          });
          continue;
        }
        if (event.flexible && eventIdsToToDisable) {
          input.events.push({
            isFlexible: true,
            externalEventId: eventId,
            flexRange: FlexRange.Day,
          });
        }
      }
    }

    await editEventFlexibility({
      variables: {
        events: input.events,
      },
      onCompleted,
      onError,
    });
  };

  return {
    update,
    updating,
    updateError,
  };
};
